import React, { Component, Fragment } from 'react';
import {Icon, Form, Modal} from 'antd'
import {Link} from 'react-router-dom'
import moment from 'moment/min/moment-with-locales'

import ButtonCustom from '../../components/default/ButtonCustom'
import TextEditorCustom from '../../components/TextEditorCustom'

import { connect } from 'react-redux'
import { fetchBoard, deleteBoard, createComment,updateComment, deleteComment } from '../../actions/board'

const confirm = Modal.confirm;

class TopicDetails extends Component {
    state = {
        commentDetail: "",
        editComment:null
    }

    componentDidMount = () => {
        const id = this.props.match.params.id
        this.props.fetchBoard(id)

    }

    renderTimeFormNow = (time) => {
        moment.locale('th');
        return moment(time).fromNow();
    }

    onBoardDeleteClick = () => {
        const boardEdit = this.props
        confirm({
            title: 'คุณต้องการลบบอร์ดนี้หรือไม่?',
            onOk() {
                boardEdit.deleteBoard(boardEdit.board.id)
            },
            onCancel() {},
        });   
    }

    onCommentDeleteClick = (comment_id) => {
        const board_id = this.props.board.id
        const commentEdit = this.props
        confirm({
            title: 'คุณต้องการลบความคิดเห็นนี้หรือไม่?',
            onOk() {
                commentEdit.deleteComment({comment_id, board_id})
            },
            onCancel() {},
        });   
    }

    onCommentSubmit = (e) => {
        e.preventDefault()
        const board_id = this.props.board.id
        let commentDetail = this.state.commentDetail
        const editComment = this.state.editComment
        if(editComment && editComment > 0){
            this.props.updateComment({ id: editComment , detail: commentDetail, board_id })
            this.setState({ commentDetail: "",editComment:null })
        }else{
            const { id } = this.props.board
            this.props.createComment({id, commentDetail})
            this.setState({ commentDetail: "",editComment:null })
        }
      
    }

    handleEditorChange= (e) => {
        let comment = this.state.commentDetail
        comment = e
        this.setState({ commentDetail: comment })
    }

    editComment = (id) => {
        const commentEdit = this
        const { comment } = commentEdit.props.board
        confirm({
            title: 'คุณต้องการแก้ไขความคิดเห็นนี้หรือไม่?',
            onOk() {
                let commentObj = comment.find(commentDetail => {
                    return commentDetail.comment_id === id
                })
                commentEdit.setState({ editComment:id, commentDetail: commentObj.detail  })
            },
            onCancel() {},
        });   
    }

    render() {
        if(Object.keys(this.props.board).length > 0){
            const {id, image, title, category_name, category_color, create_by, create_id, created, detail,  comment } = this.props.board
            const { user } = this.props
            return (
                <div className="page-list-wrap">
                    <div className="page-list topic-detail-page">
                        <div className="is-row flex-between gapb-24">
                            <div className="page-list-title is-row flex-align-start">
                                <Link to="/webboard" className="back-webboard-btn">
                                    <Icon type="left" theme="outlined" />
                                </Link>
                                {title}</div>   
                            <div className="topic-category is-desktop is-tablet-hide">
                                <span className="gapr-4">อยู่ในหัวข้อ</span> 
                                <div className="topic-category-tags" style={{backgroundColor: category_color}}>{category_name}</div>
                            </div>
                        </div>
                        <div className="topic-wrap is-row flex-align-start gapb-26">
                            <div className="gapr-24 is-desktop">
                                <img className="topic-image" src={image} alt="profile"/>
                            </div>
                            <div className="is-100">
                                <div className="is-row gapb-12 flex-between">
                                    <div className="is-row">
                                        <div className="topic-createby gapr-8">{create_by}</div>
                                        <div className="topic-time">{this.renderTimeFormNow(created)}</div>
                                    </div>
                                    <div className="is-row">
                                        {
                                            create_id === user.id &&
                                            <Fragment>
                                                <a name="edit" className="action-webboard gapr-4" href={`/topic/${id}/edit`}>Edit</a>
                                                <button type="button" name="delete" className="action-webboard" onClick={this.onBoardDeleteClick}>Delete</button>
                                            </Fragment>
                                        }
                                    </div>
                                </div>
                                
                                <div className="topic-content" dangerouslySetInnerHTML={{ __html: detail }}/>
                            </div>
                        </div>
                        {
                            comment.length > 0 &&
                            <div className="comment-list-wrap gapb-40">
                                {
                                    comment.map((comment, index) => (
                                        <div className="comment-wrap is-row flex-align-start" key={index}>
                                            <div className="gapr-48 is-desktop">
                                                <img className="comment-image" src={comment.image} alt="profile"/>
                                            </div>
                                            <div className="is-100">
                                                <div className="is-row gapb-12 flex-between">
                                                    <div className="is-row">
                                                        <div className="comment-createby gapr-8">{comment.create_by}</div>
                                                        <div className="comment-time">{this.renderTimeFormNow(comment.created)}</div>
                                                    </div>
                                                    <div className="is-row">
                                                        {
                                                            comment.create_id === user.id &&
                                                            (<button type="button" name="edit" className="action-webboard gapr-4" onClick={() => this.editComment(comment.comment_id)}>Edit</button>)
                                                        }
                                                        {
                                                            (comment.create_id === user.id || create_id === user.id )&&
                                                            <button type="button" name="delete" className="action-webboard" onClick={() => this.onCommentDeleteClick(comment.comment_id)}>Delete</button>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="comment-content is-80 is-sm-100 is-md-90" 
                                                    dangerouslySetInnerHTML={{ __html: comment.detail }}/>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        }
                        <Form onSubmit={this.onCommentSubmit}>
                            <div className="new-comment-wrap is-row flex-align-start gapb-32">
                                <div className="gapr-48 is-desktop">
                                    <img className="new-comment-image" src={this.props.user.image}  alt="profile"/>
                                </div>
                                <TextEditorCustom
                                    value={this.state.commentDetail}
                                    handleEditorChange={this.handleEditorChange}
                                />
                            </div>
                            <div className="is-row flex-end">
                                <div style={{minWidth: 160}}>
                                    <ButtonCustom
                                        borderRadius="4"
                                        color="green"
                                        label="โพสต์"
                                        fontSize={16}
                                        fontWeight="large"
                                        size="extra"
                                        htmlType="submit"
                                    />
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
            );
        } else{
            return null
        }
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        user: state.user,
        board: state.board
    }
}

const mapDispatchToProps = {
    fetchBoard,
    deleteBoard,
    createComment,
    updateComment,
    deleteComment
}

export default connect(mapStateToProps, mapDispatchToProps)(TopicDetails)
